// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluationPage-cls1_Nje","cls2":"EvaluationPage-cls2_wac EvaluationPage-cls1_Nje"};